import { render, staticRenderFns } from "./RolePermissionModal.vue?vue&type=template&id=bdd107a4&"
import script from "./RolePermissionModal.vue?vue&type=script&lang=js&"
export * from "./RolePermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionModal.vue?vue&type=style&index=0&id=bdd107a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports